import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpHandlerInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!/^(http|https):/i.test(request.url)) {
      request = request.clone({ url: environment.serverUrl + request.url });
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }
    const parts = request.url.split('/');
    const lastSegment = parts.pop() || parts.pop();
    if (lastSegment !== 'token') {
      const credentials = JSON.parse(localStorage.getItem('credentials'));
      if (credentials) {
        if(request.url !== 'https://fcm.googleapis.com/fcm/send'){
          request = request.clone({ headers: request.headers.set('Authorization', credentials.token) });
        }else {
          request = request.clone({ headers: request.headers.set('Authorization', 'key=AAAAEl6ITFM:APA91bG5hsUdlUTD0MZdPn20SbUD82efzFkNybM3Etm65xYVhPPkXUwBSiqxH7KQCoYpnEXrNrC9VFTVKdm_cI4bRwwXTx6iEK-rwBuZ_dEGEunr6ZGz5RCgDrw7ZqCxzcZOL2r2URmX') });
        }
      }
    }

    //this.loaderService.set(true);
    return next.handle(request).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
         // this.loaderService.set(false);
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.router.navigate(['login'], { replaceUrl: true });
          }
          //this.loaderService.set(false);
        }
      }
    );
  }
}
